<app-wizard-side-dialog #dialog i18n-headerText="XTIT|Unified Suite Wizard header title@@organizations.unified-create-suite-dialog.title"
                        headerText="Quick Start: Product Blueprint Setup" saveText="Apply"
                        headerGlyph="layer-group"
                        [busy]="loading" [validationFn]="validateForm.bind(this)"
                        (save)="onSubmit()"
                        [contentVisible]="!loading"
                        [isDirty]="form.dirty"
                        [errorText]="errorText" [errorMsg]="errorMsg">

    <app-wizard-dialog-step stepId="basicInfo" title="Configuration" status="current" [isValid]="form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]?.valid"
                            headerGlyph="action-settings">
        <ng-template #template>
            <app-unified-suite-step-setup [formGroup]="form"></app-unified-suite-step-setup>
        </ng-template>
    </app-wizard-dialog-step>

    <app-wizard-dialog-step stepId="review" title="Review" headerGlyph="accept">
        <ng-template #template>
            <app-unified-suite-step-review [formGroup]="form"></app-unified-suite-step-review>
        </ng-template>
    </app-wizard-dialog-step>
</app-wizard-side-dialog>
